import Service from '../service';

export default class IncreaseBalanceApprovalService extends Service {
  baseApi = '/user/increase-balance-approval';

  async sendApproval(formData) {
    const url = `${this.baseApi}`;
    return await this.postFormData(url, formData);
  }

  async getApprovals() {
    const url = `${this.baseApi}`;
    return await this.getResource(url);
  }
}
